import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BetslipQdComponent } from '@payments/betslipqd-feature';

import { ShowInEpcotDirective } from '../../../lib/common/epcot-config.directive';
import { QuickDepositAnimationDirective } from './components/quick-deposit-animation.directive';
import { QuickDepositMessageComponent } from './components/quick-deposit-message.component';
import { QuickDepositTrackingService } from './components/quick-deposit-tracking.service';
import { QuickDepositComponent } from './components/quick-deposit.component';
import { QuickDepositService } from './services/quick-deposit.service';

@NgModule({
    imports: [BetslipQdComponent, CommonModule, ShowInEpcotDirective],
    declarations: [QuickDepositComponent, QuickDepositMessageComponent, QuickDepositAnimationDirective],
    exports: [QuickDepositComponent, QuickDepositMessageComponent],
    providers: [QuickDepositService, QuickDepositTrackingService],
})
export class QuickDepositModule {}
